import { createSelector } from 'reselect'
import { RootState } from 'src/redux/createRootReducer'
import { selectVirtualCardListModels } from 'src/redux/selectors/data/virtualCards.selectors'
import { VirtualCardsFullPaginatedDataState } from 'src/redux/virtualCardsFullPaginatedData.reducer'

export const selectVirtualCardsFullPaginatedData = (
  state: RootState,
): VirtualCardsFullPaginatedDataState =>
  state.app.accounts.accountsRequests.virtualCardsFullPaginatedData
const selectUniqueVirtualCardIds = createSelector(
  [selectVirtualCardsFullPaginatedData],
  (data) => data.ids.filter((id, i) => data.ids.indexOf(id) === i),
)
const selectUniqueVirtualCardListModels = createSelector(
  [selectUniqueVirtualCardIds, selectVirtualCardListModels],
  (ids, virtualCards) => ids.map((id) => virtualCards[id]),
)
export const selectFilteredVirtualCards = createSelector(
  [selectUniqueVirtualCardListModels],
  (virtualCards) =>
    virtualCards.filter((vc) => vc.isPending || vc.pending !== undefined),
)
